import { Entity } from '@data-client/rest';
class UserEmailEntity extends Entity {
    constructor() {
        super(...arguments);
        this.email = null;
        this.userId = null;
    }
    pk() {
        return this.userId || btoa(JSON.stringify(this));
    }
}
UserEmailEntity.key = 'UserEmail';
export { UserEmailEntity };
